import { Link } from 'react-router-dom';
import { ArrowUpRight, MapPin } from 'lucide-react';

export const StatusBadge = ({ status, dark = false }) => (
  <span
    data-testid={`status-badge-${status.toLowerCase().replace(/[^a-z]/g, '-')}`}
    className={`inline-block text-[10px] uppercase tracking-[0.2em] px-3 py-1 border ${
      status === 'On-Going'
        ? 'bg-accent text-ink border-accent font-semibold'
        : dark
          ? 'border-white/30 text-white/70'
          : 'border-ink/25 text-ink/60'
    }`}
  >
    {status}
  </span>
);

export const ProjectCard = ({ project, index }) => (
  <Link
    to={`/projects/${project.slug}`}
    data-testid={`project-card-${project.slug}`}
    className="group block border border-paperline bg-white hover:border-ink transition-colors duration-500"
  >
    <div className="relative overflow-hidden aspect-[16/10]">
      <img
        src={project.image}
        alt={`${project.name} — ${project.type}, ${project.location}`}
        loading="lazy"
        className="img-treated w-full h-full object-cover group-hover:scale-105"
      />
      <div className="absolute top-4 left-4">
        <StatusBadge status={project.status} />
      </div>
      <span className="absolute bottom-4 right-4 font-display text-white/60 text-sm">
        {String(index + 1).padStart(2, '0')}
      </span>
    </div>
    <div className="p-4 flex items-start justify-between gap-4">
      <div>
        <h3 className="font-display text-lg font-medium uppercase tracking-tight leading-tight text-ink">
          {project.name}
        </h3>
        <p className="mt-1.5 text-xs text-inkmute uppercase tracking-[0.15em] flex items-center gap-2">
          <MapPin size={12} className="text-ink" fill="#ffa500" /> {project.location}
        </p>
        <p className="mt-1 text-xs text-ink/40 uppercase tracking-[0.15em]">{project.type}</p>
      </div>
      <ArrowUpRight
        size={22}
        className="shrink-0 text-ink/25 transition-all duration-300 group-hover:text-ink group-hover:translate-x-1 group-hover:-translate-y-1"
      />
    </div>
  </Link>
);
